import { OrderedList as TiptapOrderedList } from '@tiptap/extension-list'

import { OrderedListActionButton } from '@/tiptap/extensions/components/ActionButton'

export const OrderedList = TiptapOrderedList.extend({
  addOptions() {
    return {
      ...(this.parent ? this.parent() : {}),
      button: ({ editor, t }) => ({
        component: OrderedListActionButton,
        componentProps: {
          editor,
          t,
        },
      }),
    }
  },
})

export default OrderedList